import { calculateAverage, formatDuration } from '../helpers/duration.helper';
import { CumulativeAverageDurationResult } from '../dto/top-apps/cube/mapped/cumulative-avg-duration-result.dto';
import { AppAveragesResponseDto } from 'lib/dto/goals/response/app-averages-response.dto';

export const mapToAppAveragesResponse = (
  cumulativeValues: CumulativeAverageDurationResult
): AppAveragesResponseDto => {
  const response = {
    averageDailyDuration: cumulativeValues?.totalDuration
      ? Math.round(
          calculateAverage(
            cumulativeValues.totalDuration,
            cumulativeValues.dayCount
          )
        )
      : 0,
    averageDailyInteractions: cumulativeValues?.count
      ? Math.round(
          calculateAverage(cumulativeValues.count, cumulativeValues.dayCount)
        )
      : 0,
    averageWeeklyDuration: cumulativeValues?.totalDuration
      ? Math.round(
          calculateAverage(
            cumulativeValues.totalDuration,
            cumulativeValues.weekCount
          )
        )
      : 0,
    averageWeeklyInteractions: cumulativeValues?.count
      ? Math.round(
          calculateAverage(cumulativeValues.count, cumulativeValues.weekCount)
        )
      : 0,
    formattedAverageDailyDuration: cumulativeValues?.totalDuration
      ? formatDuration(
          calculateAverage(
            cumulativeValues.totalDuration,
            cumulativeValues.dayCount
          )
        )
      : '0',
    formattedAverageDailyInteractions: cumulativeValues?.count
      ? calculateAverage(
          cumulativeValues.count,
          cumulativeValues.dayCount
        ).toFixed(0)
      : '0',
    formattedAverageWeeklyDuration: cumulativeValues?.totalDuration
      ? formatDuration(
          calculateAverage(
            cumulativeValues.totalDuration,
            cumulativeValues.weekCount
          )
        )
      : '0',
    formattedAverageWeeklyInteractions: cumulativeValues?.count
      ? calculateAverage(
          cumulativeValues.count,
          cumulativeValues.weekCount
        ).toFixed(0)
      : '0',
    averageDailyCallDuration: cumulativeValues?.totalCallDuration
      ? Math.round(
          calculateAverage(
            cumulativeValues.totalCallDuration,
            cumulativeValues.dayCount
          )
        )
      : 0,
    averageDailyCallInteractions: cumulativeValues?.callCount
      ? Math.round(
          calculateAverage(
            cumulativeValues.callCount,
            cumulativeValues.dayCount
          )
        )
      : 0,
    averageWeeklyCallDuration: cumulativeValues?.totalCallDuration
      ? Math.round(
          calculateAverage(
            cumulativeValues.totalCallDuration,
            cumulativeValues.weekCount
          )
        )
      : 0,
    averageWeeklyCallInteractions: cumulativeValues?.callCount
      ? Math.round(
          calculateAverage(
            cumulativeValues.callCount,
            cumulativeValues.weekCount
          )
        )
      : 0,
    formattedAverageDailyCallDuration: cumulativeValues?.totalCallDuration
      ? formatDuration(
          calculateAverage(
            cumulativeValues.totalCallDuration,
            cumulativeValues.dayCount
          )
        )
      : '0',
    formattedAverageDailyCallInteractions: cumulativeValues?.callCount
      ? calculateAverage(
          cumulativeValues.callCount,
          cumulativeValues.dayCount
        ).toFixed(0)
      : '0',
    formattedAverageWeeklyCallDuration: cumulativeValues?.totalCallDuration
      ? formatDuration(
          calculateAverage(
            cumulativeValues.totalCallDuration,
            cumulativeValues.weekCount
          )
        )
      : '0',
    formattedAverageWeeklyCallInteractions: cumulativeValues?.callCount
      ? calculateAverage(
          cumulativeValues.callCount,
          cumulativeValues.weekCount
        ).toFixed(0)
      : '0',
  };
  return response;
};
